

const GetESourceName = (id) => {
    switch (id) {
        case 0: { return "Online" }
        case 1: { return "Offline" }
    }
}
const GetESource = {
    GetESource: [
        { Id: 0, Name: "Online" },
        { Id: 1, Name: "Offline" },
    ]
}
const ESourceBg = (id) => {
    switch (id) {
        case 1: return "bg-gray-400"
        case 0: return "bg-green-400"
    }
}

export { GetESourceName, GetESource ,ESourceBg}